<template>
  <div class="settings section__padding">
    <el-tabs v-model="activeName">
      <el-tab-pane label="Biodata" name="first">
        <Profile
          ref="profileRef"
        />
      </el-tab-pane>
      <el-tab-pane label="Address" name="second">
        <Addresses />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Profile from '@/components/settings/Profile.vue'
import Addresses from '@/components/settings/Addresses.vue'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'Setting-Page',
  components: {
    Profile,
    Addresses
  },
  data () {
    return {
      activeName: 'first'
    }
  },
  mounted () {
    this.fetchAddresses()
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },
  methods: {
    ...mapActions({
      fetchAddresses: 'address/fetchAddresses'
    })
  }
}
</script>

<style lang="scss" scoped>
.settings {
  .el-tabs::v-deep {
    .el-tabs__nav {
      .el-tabs__active-bar {
        background: var(--color-blue-background);
      }
      .el-tabs__item {
        font-size: 18px;
        font-weight: 600;
        padding: 0;
        text-align: center;
        width: 100%;
        // color: var(--color-blue-background);
        &.is-active {
          // background: var(--color-blue-background);
          // color: var(--color-yellow);
          color: var(--color-blue-background);
        }
      }
    }
    .el-tabs__content {
      margin-top: 30px;
    }
  }
}
</style>
